module.exports = __webpack_public_path__ + "static/media/Akemi_5031.5d9f7fcf.jpg";